import type { AppProps } from 'next/app';

/* CSS */
import { Environment } from '@/config/environment';
import dynamic from 'next/dynamic';
import 'styles/global.css';
import 'styles/hero-mask.css';
import 'styles/print.css';
import useWebvitals from '../hooks/useWebvitals';
import { StyleSheetManager } from 'styled-components';
import UcBlockScript from '@/components/UcBlockScript';

const GoogleTagManager = dynamic(
  () => import('@next/third-parties/google').then((mod) => mod.GoogleTagManager),
  { ssr: false },
);

export default function MyApp({ Component, pageProps }: AppProps) {
  const { NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID } = Environment.getBuildtimeEnvVars();

  useWebvitals();

  return (
    <>
      <UcBlockScript locale={pageProps.locale} />
      {NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID && (
        <GoogleTagManager gtmId={NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID} />
      )}
      <StyleSheetManager enableVendorPrefixes>
        <Component {...pageProps} />
      </StyleSheetManager>
    </>
  );
}
